import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import { useDeleteScanMutation } from '../../../../../services/entities/impl/blfApi/endpoints/scans';
import { UserRolesEnum } from '../../../../../services/entities/impl/blfApi/schemas/user';
import IconButtonProtected from '../../../../commonUI/IconButtonProtected';
import {
  initialSendStatus,
  SendStatus,
  SendStatusEnum,
} from '../../../../onboarding/onboardingUtils';

interface ScanCardDeleteButtonProps {
  scanId: string;
}

const ScanCardDeleteButton: React.FC<ScanCardDeleteButtonProps> = ({
  scanId,
}) => {
  const [deleteScan] = useDeleteScanMutation();
  const [deleteStatus, setDeleteStatus] = useState<SendStatus>({
    ...initialSendStatus,
  });

  const handleClickDelete = async (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    try {
      setDeleteStatus({
        status: SendStatusEnum.LOADING,
        message: 'Deleting scan...',
      });
      console.log('Deleting scan...', scanId);
      await deleteScan(scanId);
      setDeleteStatus({
        status: SendStatusEnum.SUCCESS,
        message: 'Scan deleted successfully.',
      });
      console.log('Scan deleted successfully.');
    } catch (e) {
      setDeleteStatus({
        status: SendStatusEnum.FAILED,
        message: 'Failed to delete scan, see console for details.',
      });
      alert('Failed to delete scan, see console for details.');
      console.log(e);
    }
  };

  if (deleteStatus.status === SendStatusEnum.FAILED) {
    console.log('Delete status: ', deleteStatus);
  }

  return (
    <IconButtonProtected
      icon={<DeleteIcon sx={{ color: '#ff7961' }} />}
      authorizedRoles={[UserRolesEnum.qa, UserRolesEnum.root]}
      handleClick={handleClickDelete}
      ariaLabel='delete scan'
      confirmationDialog
      confirmationMessage='Are you sure you want to delete this scan?'
      sendStatus={deleteStatus}
      size='small'
    />
  );
};

export default ScanCardDeleteButton;
